import { FC } from 'react';
import { useIntl } from 'react-intl';

import { usePathProps } from '../../modules/user-profile/hooks/usePathProps';
import { PageTitle } from '../../../_metronic/layout/core';
import { TaskCalendar } from '../../modules/tasks';

const AgendaComponent: FC = () => {
  return (
    <>
      <TaskCalendar />
    </>
  );
};

const AgendaPage: FC = () => {
  const intl = useIntl();
  usePathProps();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'app.pending' })}
      </PageTitle>
      <AgendaComponent />
    </>
  );
};

export { AgendaPage };
